import React, { useContext } from 'react';
import 'twin.macro';
import { Link } from 'react-router-dom';
import { Paragraph } from '../text';
import { Error } from '../error';
import { RequestContext } from '../context';
import { MetaTags } from '../meta';

export const NotFound = () => {
  const { setStatus } = useContext(RequestContext);

  if (setStatus) {
    setStatus(404);
  }

  return (
    <div tw='w-full flex flex-col items-center pt-8'>
      <MetaTags />
      <Error label='Deze pagina bestaat niet.'>
        <Paragraph tw='mt-2'>
          Klik <Link to='/'>hier</Link> om je l33t te verzachten.
        </Paragraph>
      </Error>
    </div>
  );
};
